function e(r){return ArrayBuffer.isView(r)&&!(r instanceof DataView)}export{e as isTypedArray};
